import { useState, useEffect } from 'react';
import { FiX, FiSun, FiMoon, FiChevronLeft } from 'react-icons/fi';
import { IoShareOutline } from 'react-icons/io5';
import { GoHistory } from "react-icons/go";
import { TbMessage2Star } from "react-icons/tb";
import { BiCategory } from "react-icons/bi";
import Modal from './Modal';
import RatingModal from './RatingModal';
import { CategoriesSheet } from './BottomSheet';
import { data, sideNavData } from '../data';
import { useLockBodyScroll } from '@uidotdev/usehooks';
import LoginModal from './LoginModal'; // تأكد من استيراد مكون تسجيل الدخول
import useDarkMode from '../hooks/useDarkMode';
import { useNavigate } from 'react-router-dom';
import { useRef } from 'react';
import { Switch } from '@headlessui/react';
import '../styles/animations.css';

const keyframes = `
  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes slideFromLeft {
    from {
      opacity: 0;
      transform: translateX(-20px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

  @keyframes logoAnimation {
    0% {
      opacity: 0;
      transform: scale(0.3) rotate(-30deg);
    }
    50% {
      transform: scale(1.1) rotate(5deg);
    }
    70% {
      transform: scale(0.95) rotate(-2deg);
    }
    100% {
      opacity: 1;
      transform: scale(1) rotate(0);
    }
  }
`;

export default function SideNav({ sideNav, setSideNav, swiper }) {
  const [isDarkMode, toggleDarkMode] = useDarkMode();
  const [modal1On, setModal1On] = useState(false);
  const [modal2On, setModal2On] = useState(false);
  const [modal3On, setModal3On] = useState(false);
  const [loginModalOn, setLoginModalOn] = useState(false);
  const [showButtons, setShowButtons] = useState(false);
  const [isScrollable, setIsScrollable] = useState(false);
  const scrollContainerRef = useRef(null);
  useLockBodyScroll();
  const navigate = useNavigate();

  useEffect(() => {
    if (scrollContainerRef.current) {
      const container = scrollContainerRef.current;
      setIsScrollable(container.scrollWidth > container.clientWidth);
    }
  }, [sideNav]);

  useEffect(() => {
    if (sideNav) {
      // Reset animation state
      setShowButtons(false);
      // Trigger animation after a delay to ensure complete reset
      const timer = setTimeout(() => {
        setShowButtons(true);
      }, 300);
      return () => clearTimeout(timer);
    } else {
      setShowButtons(false);
    }
  }, [sideNav]);

  const getButtonStyle = (index) => ({
    transform: showButtons ? 'translateY(0)' : 'translateY(20px)',
    opacity: showButtons ? 1 : 0,
    transition: 'all 0.3s ease-out',
    transitionDelay: showButtons ? `${index * 100}ms` : '0ms'
  });

  const share = (event) => {
    if (navigator.share) {
      navigator
        .share({
          text: 'مطعم نوى الشام : Nawa Sham',
          url: 'https://nawsham.online',
        })
        .then(() => {
          console.log('! شكراً على المشاركة');
        })
        .catch((err) => console.error(err));
    } else {
      alert('جهازك الحالي لا يدعم خاصية المشاركة');
    }
  };

  return (
    <div className='relative inset-0 flex justify-center z-[102]'>
      <div
        className={`fixed inset-0 bg-black dark:bg-white bg-opacity-70 dark:bg-opacity-70 ${sideNav ? 'block' : 'hidden'
          }`}
        onClick={() => setSideNav(false)}
      ></div>
      <div
        className={`fixed w-[350px] md:w-[447px] top-0 right-0 bg-white flex flex-col dark:bg-gray-700 h-full transition-all duration-500 ease-out rounded-sid  ${sideNav
            ? 'left-[calc(100%-350px)] md:left-[calc(100%-447px)]'
            : 'left-[100%]'
          }`}
      >
        <style>{keyframes}</style>
        <FiX
          className={`eax absolute left-1.5 top-1.5 z-103 w-5 h-5 p-0.5 mx-2 rounded-full bg-primaryGreen-500 text-gray-50 hover:bg-opacity-50 dark:hover:bg-opacity-50 transform hover:rotate-180 dark:bg-gray-700 dark:text-gray-50 ${sideNav ? 'block' : 'hidden'
            }`}
          onClick={() => setSideNav(false)}
        />
        <div
          className={`bg-primaryGreen-300 w-full dark:bg-white flex items-center justify-center pt-2 ${!sideNav && 'hidden'}`}
        >
          <img 
            src='../../img/logo.png' 
            alt='side-logo' 
            className="w-[150px] h-[150px]"
            style={{
              animation: sideNav ? 'logoAnimation 0.8s cubic-bezier(0.34, 1.56, 0.64, 1) forwards' : 'none',
              opacity: sideNav ? 1 : 0,
              transitionDelay: '100ms'
            }}
          />
        </div>
        <div className={`bg-primaryGreen-200 ${!sideNav && 'hidden'}`}>
          <div className='flex items-center justify-center'>
            <div 
              ref={scrollContainerRef}
              className={`flex ${isScrollable ? 'overflow-x-auto' : 'overflow-x-hidden'} gap-2 py-2 hide-scrollbar`}
            >
              {sideNavData.map((link, index) => (
                <div className='relative' key={link.id}>
                  <a
                    href={link.href}
                    className='flex items-center justify-center p-1 rounded-lg hover:bg-gray-300 transition-colors'
                    style={{
                      animation: sideNav ? `slideFromLeft 0.3s ease-out forwards ${300 + (index * 100)}ms` : 'none',
                      opacity: 0
                    }}
                  >
                    <link.icon className='text-primaryGreen-500 w-6 h-6' />
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div
          className={`flex flex-col w-full overflow-y-auto px-2 mt-2 gap-1 pb-2`}
        >
          <p className='py-2.5 px-4 rounded-tr-md rounded-tl-md bg-primaryGreen-200 bg-opacity-500 text-justify text-xs leading-normal text-gray-900 font-semibold cursor-pointer'>
            يحتاج البالغون إلى 2000 سعره حرارية في المتوسط يومياً، وقد تختلف
            الاحتياجات الفردية من السعرات الحرارية من شخص لآخر البيانات التغذوية
            الإضافية متاحة عند الطلب .
          </p>
          <div className="flex flex-col gap-4">
            <button
              onClick={() => {
                setSideNav(false);
                navigate('/order-history');
              }}
              className='relative flex justify-between items-center py-2.5 px-4 rounded-sm transition bg-gray-100 bg-opacity-500 text-gray-800'
              style={getButtonStyle(0)}
            >
              <div className='flex items-center gap-2'>
                <GoHistory className='text-primaryGreen-500 w-5 h-5' />
                <h1 className='text-xs md:text-md text-gray-900 font-semibold'>
                  الطلبات السابقة
                </h1>
              </div>
              <FiChevronLeft className='text-gray-400 w-5 h-5' />
            </button>
          </div>
          <button
            onClick={(e) => {
              setSideNav(false);
              share(e);
            }}
            className='relative flex justify-between items-center py-2.5 px-4 rounded-sm transition bg-gray-100 bg-opacity-500 text-gray-800'
            style={getButtonStyle(1)}
          >
            <div className='flex items-center gap-2'>
              <IoShareOutline className='text-primaryGreen-500 w-5 h-5' />
              <h1 className='text-xs md:text-md text-gray-900 font-semibold'>
                مشاركة
              </h1>
            </div>
            <FiChevronLeft className='text-gray-400 w-5 h-5' />
          </button>
          <button
            onClick={() => {
              setSideNav(false);
              setModal2On(true);
            }}
            className='relative flex justify-between items-center py-2.5 px-4 rounded-sm transition bg-gray-100 bg-opacity-500  text-gray-800'
            style={getButtonStyle(2)}
          >
            <div className='flex items-center gap-2'>
              <BiCategory className='text-primaryGreen-500 w-5 h-5' />
              <h1 className='text-xs md:text-md text-gray-900 font-semibold'>
                التصنيفات
              </h1>
            </div>
            <FiChevronLeft className='text-gray-400 w-5 h-5' />
          </button>
          <button
            onClick={() => {
              setSideNav(false);
              setModal3On(true);
            }}
            className='relative flex justify-between items-center py-2.5 px-4 rounded-sm transition bg-gray-100 bg-opacity-500  text-gray-800'
            style={getButtonStyle(3)}
          >
            <div className='flex items-center gap-2'>
              <TbMessage2Star className='text-primaryGreen-500 w-5 h-5' />
              <h1 className='text-xs md:text-md text-gray-900 font-semibold'>
                شارك برأيك
              </h1>
            </div>
            <FiChevronLeft className='text-gray-400 w-5 h-5' />
          </button>

          <div
            onClick={() => toggleDarkMode()}
            className='relative flex justify-between items-center py-2.5 px-4 rounded-br-md rounded-bl-md transition bg-gray-100 bg-opacity-500 text-gray-800 cursor-pointer'
            style={getButtonStyle(4)}
          >
            <div className='flex items-center gap-2'>
              {isDarkMode ? (
                <FiSun className='text-primaryGreen-500 w-5 h-5' />
              ) : (
                <FiMoon className='text-primaryGreen-500 w-5 h-5' />
              )}
              <h1 className='text-xs md:text-md text-gray-900 font-semibold'>
                {isDarkMode ? 'الوضع النهاري' : 'الوضع الليلي'}
              </h1>
            </div>
            <Switch
              checked={isDarkMode}
              onChange={toggleDarkMode}
              className={`${
                isDarkMode ? 'bg-gray-600' : 'bg-gray-300'
              } relative inline-flex h-5 w-9 items-center rounded-full transition-colors duration-200 ease-in-out focus:outline-none border border-gray-200`}
            >
              <span
                className={`${
                  isDarkMode ? '-translate-x-4' : 'translate-x-0'
                } pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow-md ring-0 transition duration-200 ease-in-out`}
              />
            </Switch>
          </div>

        </div>

      </div>
      {modal1On && (
        <Modal title='خريطة جوجل' setModalOn={setModal1On}>
          <iframe
            title='العنوان'
            src='https://maps.google.com/maps?width=600&amp;height=600&amp;hl=en&amp;q=عنبه و كوكيز&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed'
            className='w-full h-[400px] my-4 shadow-md'
            allowFullScreen=''
            loading='lazy'
            referrerPolicy='no-referrer-when-downgrade'
          ></iframe>
          <a
            href='https://maps.app.goo.gl/RbqkSGyGwRF6UoEi8'
            className='py-2 px-10 rounded-full bg-primaryGreen-500 text-white outline-none w-fit mx-auto'
          >
            إذهب الى خريطة جوجل
          </a>
        </Modal>
      )}

      {modal2On && (
        <CategoriesSheet 
          setModalOn={setModal2On} 
          data={data} 
          onSelectCategory={(id) => swiper.slideTo(id)} 
        />
      )}

      {modal3On && <RatingModal setModalOn={setModal3On} />}
      {loginModalOn && (
        <LoginModal title='تسجيل الدخول' setModalOn={setLoginModalOn}>
          <div className='flex flex-col gap-4 p-4'>
            <input
              type='text'
              placeholder='اسم المستخدم'
              className='p-2 border border-gray-300 rounded'
            />
            <input
              type='password'
              placeholder='كلمة المرور'
              className='p-2 border border-gray-300 rounded'
            />
            <button
              onClick={() => setLoginModalOn(false)}
              className='py-2 px-4 rounded bg-primaryGreen-500 text-white'
            >
              تسجيل الدخول
            </button>
          </div>
        </LoginModal>
      )}
    </div>
  );
}
